import { useEffect, useRef } from 'react';

export const useSaveShortcut = (onSave) => {
  const handleKeyDown = useRef(null);

  useEffect(() => {
    handleKeyDown.current = (event) => {
      if (event.key === 's' && event.ctrlKey) {
        onSave();
      }
    };

    document.addEventListener('keydown', handleKeyDown.current);

    return () => {
      document.removeEventListener('keydown', handleKeyDown.current);
    };
  }, [onSave]); // Dependency array ensures updates when onSave changes
};



export const useEscapeShortcut = (onEscape) => {
  const handleKeyDown = useRef(null);

  useEffect(() => {
    handleKeyDown.current = (event) => {
      if (event.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleKeyDown.current);

    return () => {
      document.removeEventListener('keydown', handleKeyDown.current);
    };
  }, [onEscape]); // Dependency array ensures updates when onSave changes
};

